import React from 'react'
import { faPaperclip } from '@fortawesome/free-solid-svg-icons'
import { sendingEmail } from 'client/utils/api-routes-invoice'
import {
  PixelButton,
  PixelFactoryContext,
  PixelIcon,
  PixelInput,
  colors,
} from 'pixel-base'
import { env } from 'shared/env'
import styled from 'styled-components'

import { IPixelFactory } from '../../../../../../decl.d'

const Email = (props) => {
  const baseURL = env.SERVER_ADDR
  const getPrintLink = () => {
    const { token } = JSON.parse(
      localStorage.getItem('user_info') || '{token: null}',
    )
    return `${baseURL}api/v2/print/invoice/${token}/${invoiceId}`
  }
  const { invoiceData, customerData, invoiceId, handleClose } = props
  const { showFailure, showSuccess, showPageLoader, hidePageLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)

  const [data, setData] = React.useState({
    to_email: '',
    subject: '',
    body: '',
  })

  const handleSubmit = () => {
    showPageLoader()
    sendingEmail(invoiceId, data).subscribe((res: any) => {
      hidePageLoader()
      if (res?.response) {
        showSuccess('Email Sent successfully')
        handleClose(res?.response)
      } else {
        showFailure('Something Went Wrong')
        handleClose(res?.response)
      }
    })
  }

  React.useEffect(() => {
    setData({
      to_email: customerData.email,
      subject: `Invoice Created # ${invoiceData.source_order_id}`,
      body: getPrintLink(),
    })
  }, [invoiceData, customerData])

  return (
    <Form>
      <FormGroup>
        <FilterInput>
          <InputLabel>Email</InputLabel>
          <PixelInput
            type="email"
            placeholder="Email"
            name="email"
            value={data.to_email}
            onChange={(e) => {
              setData({ ...data, to_email: e.target.value })
            }}
          />
        </FilterInput>
        <FilterInput>
          <InputLabel>
            Attachment <PixelIcon fontSize="15px" icon={faPaperclip} />
          </InputLabel>

          <PixelInput
            disabled
            type="text"
            placeholder="Subject"
            name="subject"
            value={data.subject}
            onChange={(e) => {
              setData({ ...data, subject: e.target.value })
            }}
          />
        </FilterInput>

        <FilterInput>
          <InputLabel>Body</InputLabel>
          <PixelInput
            as="textarea"
            placeholder="Body"
            name="body"
            value={data.body}
            onChange={(e) => {
              setData({ ...data, body: e.target.value })
            }}
          />
        </FilterInput>
      </FormGroup>
      <ButtonContainer>
        <PixelButton variant="outline" onClick={handleClose}>
          Close
        </PixelButton>
        <PixelButton variant="primary" onClick={handleSubmit}>
          Send
        </PixelButton>
      </ButtonContainer>
    </Form>
  )
}

const Form = styled.form<{ gap?: boolean }>`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
  gap: ${(props) => (props.gap ? '0' : '10px')};
`

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
  width: 100%;
  flex-grow: 1;
  gap: 10px;
  .full-width {
    flex-grow: 1;
  }
`

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  align-content: center;
  gap: 10px;
  width: 100%;
`
const InputLabel = styled.label`
  font-size: 16px;
  font-weight: 500;
  color: ${colors.grayMedium};
  margin-left: 10px;
`
const FilterInput = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
  width: 100%;
  gap: 5px;
`

export default Email
